import MomentUtils from "@date-io/moment";
import { Tooltip } from "@material-ui/core";
import { AddOutlined, DeleteOutline as DeleteOutlineIcon } from "@material-ui/icons";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import moment from "moment";
import { isSingleOperationTaken } from "../../../constants";
import { fmt3 } from "../../../utils";

const CargoOperationTable = ({
  handleDateChange = () => { },
  data = [],
  columns = [],
  handleInputChanges = () => { },
  onAddRow = () => { },
  onDeleteRow = () => { },
  onPortChange = () => { },
  onButtonClick = () => { },
  freightMode = "Single Freight",
  isReadOnly = false,
}) => {
  return (
    <div className="w-full max-w-full min-w-0 overflow-x-auto overflow-y-hidden border-none rounded-none bg-white scroll-thin pb-0 shadow-none">
      <table className="w-full min-w-full border-collapse text-[11px]">
        <thead>
          <tr className="bg-[#313C4C] text-white h-[24px]">
            {!isReadOnly && (
              <th className="w-[24px] min-w-[24px] text-center border-r border-b border-[#5b6779] px-0.5 py-0.5 align-middle font-medium text-[11px] h-[24px]">
                <span className="sr-only">Add</span>
              </th>
            )}
            {columns.map((col, colIdx) => {
              const isLastCol = isReadOnly && colIdx === columns.length - 1;
              const isOpCol = col.key === 'operation';
              const isPortCol = col.key === 'port';
              let thClass = `px-1 py-0.5 text-[11px] align-middle font-medium ${isLastCol ? '' : 'border-r'} border-b border-[#5b6779] text-left whitespace-nowrap text-white capitalize h-[24px]`;
              if (isOpCol || isPortCol) thClass += " w-[105px] min-w-[105px] px-1.5";
              if (col.key === 'portExp') thClass += " w-[55px] max-w-[55px] px-0.5 text-left";
              if (col.key === 'laytimes') thClass += " min-w-[110px]";
              const colLabel = isOpCol ? 'Operation' : col.label;
              return (
                <th
                  key={col.key}
                  className={thClass}
                >
                  {colLabel}
                </th>
              );
            })}
            {!isReadOnly && (
              <th className="w-[24px] min-w-[24px] text-center border-b border-[#5b6779] px-0.5 py-0.5 align-middle font-medium text-[11px] h-[24px]">
                <span className="sr-only">Delete</span>
              </th>
            )}
          </tr>
        </thead>
        <tbody className="bg-white divide-y-0">
          {data?.map((row, index) => (
            <tr
              key={index}
              className="h-[19px] hover:bg-amber-50/50 transition-colors"
            >
              {!isReadOnly && (
                <td className="border-r border-b border-[#cbd5e1] text-center p-0 align-middle w-[24px] h-[19px] bg-white">
                  <Tooltip title="Add Row" placement="left" arrow>
                    <button
                      type="button"
                      onClick={() => onAddRow(index)}
                      className="w-full h-full flex items-center justify-center text-slate-500 hover:text-slate-900 hover:bg-slate-100 transition-colors border-none bg-transparent cursor-pointer p-0"
                    >
                      <AddOutlined className="!text-[13px]" />
                    </button>
                  </Tooltip>
                </td>
              )}
              {columns.map((col) => {
                const value = row[col.key];

                if (col.isBtn) {
                  const isSingleFreight = freightMode?.toLowerCase() === 'single freight';
                  let isLoading = false;
                  if (col.key === 'laytimes') {
                    isLoading = row.operation?.toLowerCase() === 'loading';
                  } else if (col.key === 'issueInvoice') {
                    isLoading = row.operation?.toLowerCase() === 'loading';
                  }

                  if (col.key === 'issueInvoice' || col.key === 'laytimes') {
                    if (!isLoading) {
                      return <td key={col.key} className={`border-r border-b border-[#cbd5e1] p-0 align-middle h-[19px] ${col.key === 'laytimes' ? 'bg-[#f1f5f9]' : 'bg-[#ffffd6]'}`} />;
                    }

                    if (isSingleFreight && col.key === 'issueInvoice') {
                      const firstLoadingIndex = data?.findIndex(
                        (item) => item.operation?.toLowerCase() === 'loading'
                      );

                      if (index !== firstLoadingIndex) {
                        return <td key={col.key} className={`border-r border-b border-[#cbd5e1] p-0 align-middle h-[19px] ${col.key === 'laytimes' ? 'bg-[#f1f5f9]' : 'bg-[#ffffd6]'}`} />;
                      }
                    }

                    return (
                      <td key={col.key} className="border-r border-b border-[#cbd5e1] p-0 align-middle h-[19px] bg-[#ffffd6] whitespace-nowrap">
                        <div className="flex items-center justify-center w-full h-full px-1">
                          <button
                            type="button"
                            className="text-[11px] font-medium text-black underline hover:text-black bg-transparent border-none p-0 cursor-pointer capitalize transition-colors whitespace-nowrap leading-none"
                            onClick={() => onButtonClick(index, row, col.key)}
                          >
                            {col.key === 'issueInvoice' ? 'Issue Invoice' : 'View'}
                          </button>
                        </div>
                      </td>
                    );
                  }

                  return (
                    <td key={col.key} className="border-r border-b border-[#cbd5e1] p-0 align-middle h-[19px] bg-[#ffffd6] whitespace-nowrap">
                      <div className="flex items-center justify-center w-full h-full px-1">
                        <button
                          type="button"
                          className="text-[11px] font-medium text-black underline hover:text-black bg-transparent border-none p-0 cursor-pointer capitalize transition-colors whitespace-nowrap leading-none"
                          onClick={() => onButtonClick(index, row, col.key)}
                        >
                          View
                        </button>
                      </div>
                    </td>
                  );
                }

                if (col.type === "datetime") {
                  return (
                    <td
                      key={col.key}
                      className="border-r border-b border-[#cbd5e1] p-0 align-middle h-[19px] bg-[#ffffd6] whitespace-nowrap"
                    >
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <Tooltip
                          title={
                            value
                              ? `Selected: ${value}`
                              : "Select date and time"
                          }
                          placement="top"
                          arrow
                        >
                          <div className="flex items-center w-[122px] h-full px-0.5">
                            <KeyboardDateTimePicker
                              size="small"
                              className="laytime-datepicker w-full bg-transparent h-[18px] text-[11px] text-black !m-0 !p-0 [&_.MuiFormControl-root]:!m-0 [&_.MuiFormControl-root]:!p-0 [&_.MuiFormControl-root]:!h-[18px] [&_.MuiFormControl-root]:!flex-row [&_.MuiFormControl-root]:!items-center [&_.MuiInputBase-root]:!h-[18px] [&_.MuiInputBase-root]:!flex-row [&_.MuiInputBase-root]:!items-center [&_.MuiInputBase-root]:!w-full [&_.MuiInputBase-root]:!min-h-0 [&_.MuiInputBase-root]:!bg-transparent [&_.MuiInputBase-root]:!bg-none [&_.MuiInputBase-input]:!h-[18px] [&_.MuiInputBase-input]:!py-0 [&_.MuiInputBase-input]:!px-0.5 [&_.MuiInputBase-input]:!text-[11px] [&_.MuiInputBase-input]:!leading-[18px] [&_.MuiInputBase-input]:!bg-transparent [&_input]:!bg-transparent [&_input[readonly]]:!bg-transparent [&_input::placeholder]:!text-[9.5px] [&_input::placeholder]:!text-black [&_.MuiInput-underline]:before:!border-none [&_.MuiInput-underline]:after:!border-none [&_.MuiInputAdornment-root]:!ml-0 [&_.MuiInputAdornment-root]:!h-[18px] [&_.MuiInputAdornment-root]:!p-0 [&_.MuiIconButton-root]:!p-0 [&_.MuiIconButton-root]:!h-[12px] [&_.MuiIconButton-root]:!w-[12px] [&_.MuiIconButton-root]:!min-w-[12px] [&_.MuiIconButton-root]:!min-h-[12px] [&_.MuiIconButton-root]:!bg-transparent [&_.MuiSvgIcon-root]:!w-2.5 [&_.MuiSvgIcon-root]:!h-2.5 [&_.MuiSvgIcon-root]:!text-[9px] [&_.MuiInputBase-root.Mui-focused]:ring-1 [&_.MuiInputBase-root.Mui-focused]:ring-inset [&_.MuiInputBase-root.Mui-focused]:ring-orange-500 [&_.MuiInputBase-root.Mui-focused]:bg-white"
                              format="DD/MM/YYYY HH:mm"
                              value={
                                value ? moment(value, ["DD/MM/YYYY HH:mm", "YYYY-MM-DD HH:mm:ss.S", "YYYY-MM-DD HH:mm"]) : null
                              }
                              onChange={(date) =>
                                handleDateChange(index, col.key, date)
                              }
                              inputProps={{
                                placeholder: "DD/MM/YYYY",
                                style: {
                                  fontSize: "11px",
                                  fontWeight: "normal",
                                  padding: "0px",
                                  height: "18px",
                                  color: "#1e293b",
                                  lineHeight: "18px",
                                },
                              }}
                              InputProps={{
                                disableUnderline: true,
                                style: {
                                  fontSize: "11px",
                                  fontWeight: "normal",
                                  paddingRight: "0px",
                                  padding: "0px",
                                  marginTop: "0px",
                                  height: "18px",
                                },
                              }}
                              keyboardIcon={
                                <CalendarTodayIcon
                                  style={{
                                    fontSize: "0.55rem",
                                    color: "#64748b",
                                  }}
                                />
                              }
                              InputAdornmentProps={{
                                position: "end",
                                style: {
                                  margin: 0,
                                  padding: 0,
                                },
                              }}
                              KeyboardButtonProps={{
                                style: {
                                  padding: 0,
                                  margin: 0,
                                  width: "12px",
                                  height: "12px",
                                  minWidth: "12px",
                                },
                                title: "Select date and time",
                              }}
                              disableMaskedInput={false}
                              error={false}
                              helperText={null}
                              FormHelperTextProps={{
                                style: { display: "none" },
                              }}
                              onError={() => { }}
                            />
                          </div>
                        </Tooltip>
                      </MuiPickersUtilsProvider>
                    </td>
                  );
                }

                if (col.type === "selection") {
                  return (
                    <td
                      key={col.key}
                      className="border-r border-b border-[#cbd5e1] p-0 align-middle h-[19px] bg-[#ffffd6] whitespace-nowrap"
                    >
                      <Tooltip title={value || "Empty"} placement="top" arrow>
                        <select
                          value={value || ""}
                          onChange={(e) => handleInputChanges(index, col.key, e.target.value)}
                          className="cargo-table-select w-full h-[19px] text-[11px] text-black bg-transparent border-none outline-none px-0.5 py-0 cursor-pointer font-medium capitalize leading-[19px] text-left"
                        >
                          {col.options.map((option) => (
                            <option key={option} value={option} className="capitalize">
                              {option}
                            </option>
                          ))}
                        </select>
                      </Tooltip>
                    </td>
                  );
                }

                if (col.editable) {
                  const isPortExp = col.key === 'portExp';
                  const displayVal = typeof value === 'number' ? fmt3(value) : (value || "");
                  return (
                    <td
                      key={col.key}
                      className={`border-r border-b border-[#cbd5e1] p-0 align-middle h-[19px] bg-[#ffffd6] whitespace-nowrap ${isPortExp ? 'w-[55px] max-w-[55px]' : ''}`}
                    >
                      <Tooltip title={displayVal || "Empty"} placement="top" arrow>
                        <input
                          type="text"
                          className="cargo-table-input w-full h-[19px] text-[11px] text-black bg-transparent border-none outline-none px-0.5 py-0 font-medium capitalize leading-[19px] text-left"
                          value={displayVal}
                          onChange={(e) =>
                            handleInputChanges(index, col.key, e.target.value)
                          }
                          onBlur={(e) => {
                            const val = e.target.value;
                            if (val !== "" && val !== null && val !== undefined && !isNaN(Number(val))) {
                              handleInputChanges(index, col.key, fmt3(val));
                            }
                          }}
                        />
                      </Tooltip>
                    </td>
                  );
                }

                const isPortCol = col.key === 'port';
                const isOpCol = col.key === 'operation';
                let cellBg = col.bg || "#ffffff";
                if (isPortCol) {
                  cellBg = "#f1f5f9";
                } else if (isOpCol) {
                  cellBg = (index === 0 && !isReadOnly) ? "#f1f5f9" : "#ffffd6";
                }

                const formatStaticValue = (val, key) => {
                  if (val === "" || val === null || val === undefined) return "";
                  if (key === 'port' || key === 'operation') return val;
                  if (typeof val === 'number') return fmt3(val);
                  if (!isNaN(Number(val))) return fmt3(val);
                  return val;
                };

                return (
                  <td
                    key={col.key}
                    className={`p-0 align-middle h-[19px] border-r border-b border-[#cbd5e1] text-[11px] whitespace-nowrap ${(isOpCol || isPortCol) ? `w-[105px] min-w-[105px]${isOpCol ? '' : ' px-1.5'}` : ''}`}
                    style={{
                      backgroundColor: cellBg,
                    }}
                  >
                    <div className="flex items-center w-full h-[19px]">
                      {isOpCol ? (
                        <Tooltip title={value || ""} placement="top" arrow>
                          <select
                            className="cargo-table-select w-full h-[19px] text-[11px] font-medium text-black bg-transparent border-none outline-none px-1.5 py-0 cursor-pointer capitalize disabled:bg-[#f1f5f9] disabled:text-black leading-[19px] text-left"
                            value={value || ""}
                            disabled={isReadOnly || index === 0}
                            onChange={(e) => {
                              onPortChange(index, col.key, e.target.value)
                            }}
                          >
                            <option value="Commence" disabled={index !== 0} hidden={index !== 0} className="capitalize">Commence</option>
                            <option value="Loading" className="capitalize">Loading</option>
                            <option value="Passing" className="capitalize">Passing</option>
                            <option value="Delivery-out" disabled={isSingleOperationTaken(data, "Delivery-out") && value !== "Delivery-out"} className="capitalize">Delivery-out</option>
                            <option value="Redelivery-in" disabled={isSingleOperationTaken(data, "Redelivery-in") && value !== "Redelivery-in"} className="capitalize">Redelivery-in</option>
                            <option value="Redelivery-out" className="capitalize">Redelivery-out</option>
                            <option value="Waiting" className="capitalize">Waiting</option>
                            <option value="Bunkering" className="capitalize">Bunkering</option>
                            <option value="Redelivery" className="capitalize">Redelivery</option>
                            <option value="Relay" className="capitalize">Relay</option>
                            <option value="Discharging" className="capitalize">Discharging</option>
                          </select>
                        </Tooltip>
                      ) : (
                        <span className={`truncate block w-full font-medium text-black capitalize leading-[19px] text-left ${isPortCol ? '' : 'px-1'}`}>
                          {formatStaticValue(value, col.key)}
                        </span>
                      )}
                    </div>
                  </td>
                );
              })}
              {!isReadOnly && (
                <td className="border-b border-[#cbd5e1] text-center p-0 align-middle w-[24px] h-[19px] bg-white">
                  <Tooltip title="Delete Row" placement="top" arrow>
                    <button
                      type="button"
                      onClick={() => onDeleteRow(index)}
                      disabled={data.length <= 1}
                      className="w-full h-full flex items-center justify-center text-rose-500 hover:text-rose-700 disabled:text-slate-300 hover:bg-rose-50 transition-colors border-none bg-transparent cursor-pointer p-0"
                    >
                      <DeleteOutlineIcon className="!text-[13px]" />
                    </button>
                  </Tooltip>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CargoOperationTable;
